/** Discrete DSP marketplace clicks volume levels (1–7). */
export const CLICKS_VOLUME_MIN = 1;
export const CLICKS_VOLUME_MAX = 7;
export const CLICKS_VOLUME_DEFAULT = 4;

export const CLICKS_VOLUME_LEVELS = [
	{ value: 1, label: "Very low", short: "VL" },
	{ value: 2, label: "Low", short: "L" },
	{ value: 3, label: "Below medium", short: "BM" },
	{ value: 4, label: "Medium", short: "M" },
	{ value: 5, label: "Above medium", short: "AM" },
	{ value: 6, label: "High", short: "H" },
	{ value: 7, label: "Very high", short: "VH" },
];

export function clampClicksVolume(value) {
	const n = Math.round(+value);
	if (!Number.isFinite(n)) {
		return CLICKS_VOLUME_DEFAULT;
	}
	return Math.min(CLICKS_VOLUME_MAX, Math.max(CLICKS_VOLUME_MIN, n));
}

export function getClicksVolumeLabel(value) {
	const level = CLICKS_VOLUME_LEVELS.find((item) => item.value === clampClicksVolume(value));
	return level ? level.label : "Medium";
}

export function isDspMarketplacePublisher(publisher) {
	return publisher?.publisher_type === "marketplace" && publisher?.media_type === "dsp";
}

export function isDspMarketplacePublisherRow(publisher) {
	return (
		publisher?.publisher_type === "marketplace" &&
		(publisher?.publisher_media_type === "dsp" || publisher?.media_type === "dsp")
	);
}
